var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"input-button",class:_vm.classObject,on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }